import axios from 'axios';

const api = axios.create({
    baseURL: 'https://m3dstudio.com.br',
});

export default api;